// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoWagering_container__MpKKG{
    display: flex;
    flex-direction: column;
    gap:10px;
    padding: 10px;

    font-family: Popins,sans-serif;



}

.InfoWagering_rule__8igzE{
    display: flex;
    gap:5px;
    align-items: flex-start;
    justify-content: flex-start;
    color:ghostwhite;

}
.InfoWagering_rulik__i9wzO{
    font-size: 15px;
    color:rgba(248, 248, 255, 0.687);
}
.InfoWagering_status__NoswE{
    display: flex;
    justify-content:center;
    gap:5px;
    color:white;
    font-family: Popins,sans-serif; 
    border-radius: 20px;
    align-items: center;


}
.InfoWagering_info_wager__gnf9W{
    display: flex;
    color:white;
    font-family: Popins,sans-serif;
    padding: 10px;
    border-radius: 20px;
    align-items: center;
    background-color: rgb(137 121 30 / 28%);
    color: gold;
}
.InfoWagering_header__cX0Fc{
    font-size: 25px;
    color:white;
    font-weight: 600;
}
.InfoWagering_circle__cp\\+0H{
    font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Payments/components/InfoWagering/InfoWagering.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;;IAEb,8BAA8B;;;;AAIlC;;AAEA;IACI,aAAa;IACb,OAAO;IACP,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;;AAEpB;AACA;IACI,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;;;AAGvB;AACA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uCAAuC;IACvC,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB","sourcesContent":[".container{\n    display: flex;\n    flex-direction: column;\n    gap:10px;\n    padding: 10px;\n\n    font-family: Popins,sans-serif;\n\n\n\n}\n\n.rule{\n    display: flex;\n    gap:5px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    color:ghostwhite;\n\n}\n.rulik{\n    font-size: 15px;\n    color:rgba(248, 248, 255, 0.687);\n}\n.status{\n    display: flex;\n    justify-content:center;\n    gap:5px;\n    color:white;\n    font-family: Popins,sans-serif; \n    border-radius: 20px;\n    align-items: center;\n\n\n}\n.info_wager{\n    display: flex;\n    color:white;\n    font-family: Popins,sans-serif;\n    padding: 10px;\n    border-radius: 20px;\n    align-items: center;\n    background-color: rgb(137 121 30 / 28%);\n    color: gold;\n}\n.header{\n    font-size: 25px;\n    color:white;\n    font-weight: 600;\n}\n.circle{\n    font-size: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InfoWagering_container__MpKKG`,
	"rule": `InfoWagering_rule__8igzE`,
	"rulik": `InfoWagering_rulik__i9wzO`,
	"status": `InfoWagering_status__NoswE`,
	"info_wager": `InfoWagering_info_wager__gnf9W`,
	"header": `InfoWagering_header__cX0Fc`,
	"circle": `InfoWagering_circle__cp+0H`
};
export default ___CSS_LOADER_EXPORT___;
